import './BlockVideo.css';

function BlockVideo(props) {
 
  return (
    <div id="BlockVideo">
      {/* <img className={`BlockContent-img ${props.shadow === false ? 'no-shadow' : ''}`}  src={props.src} alt=''/>
       */}
          <video className={`BlockContent-vid ${props.shadow === false ? 'no-shadow' : ''}`} width="100%"controls >
                <source src={props.src} type="video/mp4"/>
            </video>
            <p className='BlockContent-vid-title' dangerouslySetInnerHTML={{ __html: props.title }} />
    </div>

  );
}

export default BlockVideo;
